import { PageHeader, Panel, Tag } from "@/components/common";
import { Fingerprint } from "@phosphor-icons/react";

const ASSETS = [];

export default function Provenance() {
  return (
    <div>
      <PageHeader icon={Fingerprint} title="IP / Asset Provenance"
        subtitle="Every important asset stores creator, AI provider/model, date, prompt and commercial-use information — critical for future merchandising and licensing." />

      <Panel className="p-0 overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-xs uppercase tracking-wider text-zinc-500 border-b border-white/5">
              <th className="p-4 font-medium">Asset</th><th className="p-4 font-medium">Type</th>
              <th className="p-4 font-medium">Provider / Model</th><th className="p-4 font-medium">Date</th>
              <th className="p-4 font-medium">Commercial use</th><th className="p-4 font-medium hidden lg:table-cell">Prompt / version</th>
            </tr>
          </thead>
          <tbody>
            {ASSETS.length === 0 && <tr><td colSpan="6" className="p-6 text-sm text-zinc-400 text-center">No provenance records yet. Real generated and uploaded assets will be listed here.</td></tr>}
            {ASSETS.map((a, i) => (
              <tr key={i} data-testid={`asset-${i}`} className="border-b border-white/5 last:border-0 hover:bg-white/[0.02]">
                <td className="p-4 text-white font-medium">{a.name}</td>
                <td className="p-4"><Tag>{a.type}</Tag></td>
                <td className="p-4 text-zinc-400">{a.provider}</td>
                <td className="p-4 text-zinc-500 font-mono text-xs">{a.date}</td>
                <td className={`p-4 ${a.commercial.startsWith("Unknown") ? "text-[#FFB800]" : "text-[#00FF9D]"}`}>{a.commercial}</td>
                <td className="p-4 text-zinc-500 font-mono text-xs hidden lg:table-cell">{a.prompt}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Panel>
    </div>
  );
}
